const defaultState = () => ({
    flowmeters: [],
    massBalanceStep: [],
    analysis: [],
    products: [],
});

const mutations = {
    setFlowmeterNetwork(state, flowmeters) {
        Object.assign(state, flowmeters);
    },
    setMassBalanceStep(state, massBalanceStep) {
        Object.assign(state, massBalanceStep);
    },
    setanalysis(state, analysis) {
        Object.assign(state, analysis);
    },
    setproducts(state, products) {
        Object.assign(state, products);
    },
    resetMassBalanceData(state) {
        Object.keys(state).forEach(key => {
            state[key] = [];
        });
    },
};

const actions = {
    setFlowmeterNetwork({ commit }, data) {
        commit('setFlowmeterNetwork', data);
    },
    setMassBalanceStep({ commit }, data) {
        commit('setMassBalanceStep', data);
    },
    setanalysis({ commit }, data) {
        commit('setanalysis', data);
    },
    setproducts({ commit }, data) {
        commit('setproducts', data);
    },
    resetMassBalanceData({ commit }) {
        commit('resetMassBalanceData');
    },
};

const getters = {
    massBalanceData: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
